import { render } from "./RefundReview.vue?vue&type=template&id=76af9c14&scoped=true"
import script from "./RefundReview.vue?vue&type=script&lang=js"
export * from "./RefundReview.vue?vue&type=script&lang=js"

import "./RefundReview.vue?vue&type=style&index=0&id=76af9c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76af9c14"]])

export default __exports__